import { AIBadgeIcon } from '../informative/AIBadge';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
export const AIBadgeButton = ({
  onClick,
  use = 'filled'
}) => {
  return /*#__PURE__*/_jsx(Button, {
    onClick: onClick,
    paddingBlock: "0",
    paddingInline: "0",
    use: "unstyled",
    children: /*#__PURE__*/_jsx(AIBadgeIcon, {
      use: use
    })
  });
};
AIBadgeButton.displayName = 'AIBadgeButton';